import {NotAuthorizedPage} from './components';
import React from 'react';
import {
  ActivateAccountPage,
  LogInPage,
  LogOutPage,
  VerifyAccountActivationTokenPage,
  VerifyUserPage,
} from './containers';

import {
  CreateAccountProfilePage,
} from './components';

import {Redirect, Route} from 'react-router';

export default (
  <Route>
    <Route path="verify-user" component={VerifyUserPage} />
    <Redirect from="login" to="log-in" />
    <Route path="log-in" component={LogInPage} />

    <Route path="create-profile/:userId" component={CreateAccountProfilePage} />

    <Route path="verify-account-activation-token/:userId/:token" component={VerifyAccountActivationTokenPage} />
    <Route path="create-account/:userId/:token" component={ActivateAccountPage} />

    <Redirect from="logout" to="log-out" />
    <Route path="log-out" component={LogOutPage} />
    <Route path="not-authorized" component={NotAuthorizedPage} />
  </Route>
);



// WEBPACK FOOTER //
// ./app/features/authentication/routes.js